import Vue from 'vue'
import App from './App'
import router from './router'

// 导入 axios
import axios from 'axios'
import domain from './js/domain.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


// 登录页样式
import './css/login.css'

// 公共方法
import mixin from './js/mixin'
import myHeader from './components/header'
import myFooter from './components/footer'
import Banner from './components/banner'
import CustomerService from './components/customerService'
import Logout from './components/logout'

global.domain = domain;
// 全局配置 axios 请求的根路径, 可以不写.
axios.defaults.baseURL = domain.api
// 把 axios 挂载到 Vue 原型上. 今后,在每个 .vue 组件中发起请求,直接调用 this.$http 即可.
Vue.prototype.$http = axios


Vue.mixin(mixin)

Vue.component('myHeader', myHeader)
Vue.component('myFooter', myFooter)
Vue.component('Banner', Banner)
Vue.component('CustomerService', CustomerService)
Vue.component('Logout', Logout)

Vue.use(ElementUI);

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js